module.exports = __webpack_public_path__ + "static/media/GooglePlayBlack.2dd09a49.png";